import { onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';

export default function useRealtimeDoc({ docRef = null, transformData = null }) {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!docRef) {
      setData(null);
      setStatus('Not a valid doc ref');
      return undefined;
    }

    const unsubscribe = onSnapshot(docRef, (snapshot) => {
      const docData = snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;

      if (typeof transformData === 'function' && !!docData) {
        try {
          setData(transformData(snapshot));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error transforming data for doc:', snapshot.id, error);
          setData(docData);
        }
      } else {
        setData(docData);
      }

      setStatus('success');
    }, () => {
      setData(null);
      setStatus('error');
    });

    return () => {
      unsubscribe();
      setData(null);
      setStatus('loading');
    };
  }, [docRef, transformData]);

  return { data, status };
}
